const environment = {
    production: true,
    version: '2.4.1',
    build_time: '1632227846044',
    notes: [
        'Better support for large clause libraries in suggested clauses',
        'Suggested clause filtering',
        'Access to full clause library from suggested clauses',
        'Updated help text for the Scorecards and Clauses',
        'Release notes dialog can be opened at any time, with link to User Guide'
    ],
    userGuideUrl: 'https://support.docusign.com/en/guides/DocuSign-Analyzer-Guide-v2-4-1-x'
};

export { environment as default };
